import React from 'react';
import cx from 'classnames';
import { Image, Icon, Text, Button } from '../../../../../../../ui-kit';
import { CreditsOverview } from '../../../../../index';
import '../styles/_credit-menu.scss';










export default function CreditMenu({
  creditType,
  creditBalance,
  isUnlimited,
  teams,
  hasTeamsCredits,
  onLiveChatModalOpen
}) {
  if (creditType === 'TEAM' && !teams.length) {
    return <Text noMargin>{'You aren\'t in any teams with credits.'}</Text>;
  }

  return (
    <div className="credit-menu">
      {
      !hasTeamsCredits ?

      <div className={cx('credit-menu__share', { 'credit-menu__share--no-margin': isUnlimited })}>
              <CreditsOverview
          creditBalance={creditBalance}
          isUnlimited={isUnlimited} />

            </div> :


      <div className={cx('credit-menu__teams', { 'credit-menu__teams--no-margin': isUnlimited })}>
              {
        teams.map(({ teamId, imageUrl, name, creditBalance: teamBalance }) => {
          const totalAvailableCredits = teamBalance.balance + teamBalance.rolloverBalance;

          return (
            <div key={teamId} className="credit-menu__teams__team">
                      <div className="credit-menu__teams__team__image">
                        <Image
                  width="50px"
                  height="50px"
                  placeholderText={name}
                  placeholderTextSize={15}
                  defaultIconColour="regent"
                  imageUrl={imageUrl}
                  rounded />

                      </div>
                      <div className="credit-menu__teams__team__info">
                        <Text heading5 noMargin>{name}</Text>
                        <div className="credit-menu__teams__team__info__credits">
                          <Icon
                    name="credits"
                    size={15}
                    color="black" />

                          <Text label noMargin>{`${totalAvailableCredits} credits`}</Text>
                        </div>
                      </div>
                    </div>);

        })}

            </div>}


      {!isUnlimited &&
      <div className="credit-menu-subscription-v22__teams__button">
          <Button
          onClick={onLiveChatModalOpen}
          type="PRIMARY"
          prefix={<Icon name="flashon" size={20} color="darkDenim" />}>

            Top Up Now
          </Button>
        </div>}

    </div>);

}